import { Meal } from "@/clients/models/Meal";
import { StackedModal } from "@/components/modal/stacked-modal";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { memo } from "react";
import { PlanDetailBottomSheetHeader } from "../ingredients-modal/plan-detail-bottom-sheet-header";

interface MethodModalProps {
  pageRef: React.RefObject<HTMLElement>;
  isOpen: boolean;
  onDismiss: () => void;
  meal: Meal;
}

export const MethodModal = memo(function MethodModal({
  pageRef,
  isOpen,
  onDismiss,
  meal,
}: MethodModalProps) {
  return (
    <StackedModal
      pageRef={pageRef}
      isOpen={isOpen}
      onDidDismiss={onDismiss}
      showHeader={false}
      classNames={{ content: "overflow-y-hidden" }}
      forceOverscroll={false}
    >
      <div className="relative flex h-full flex-col overflow-hidden">
        <div
          className={cn(
            "pointer-events-none absolute -top-1 -right-1 -left-1 h-[251px]",
            "to-screen-gs-1 bg-gradient-to-t from-[rgba(96,65,138,0)]",
          )}
        />
        <PlanDetailBottomSheetHeader title="Method" onDismiss={onDismiss} />
        <div className="flex flex-1 flex-col overflow-y-auto pb-8">
          {meal.description && meal.description.length > 0 && (
            <p className={cn(textVariants.bodySmall, "relative z-10 pb-8 text-center text-white")}>
              {meal.description}
            </p>
          )}
          <div className="relative z-10 flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto px-7.5 pt-16">
            {meal.instructions?.map((instruction, index) => (
              <div key={index} className="flex items-center gap-4">
                <span className={cn(textVariants.largeTitle, "text-screen-gs-1 font-semibold")}>
                  {index + 1}
                </span>

                <div className="flex-1 pt-1">
                  <p className={cn(textVariants.body, "text-[#5A5757]")}>{instruction}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </StackedModal>
  );
});
